import { IconButton } from "@itk/mui-components";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import productImage from "src/assets/images/dummy-product-images/image 125.png";
import { DekoxIcon } from "src/components/deko-x-icons/dekox-icons";
import { genericTranslationsK } from "src/translation-hooks/generic-translations";
import { ITEM_CARD_IMAGE_HEIGHT } from "../../add-edit-configuration-dialog-types";
import { getClickableProps } from "src/utils/keyboard-utils";

type Props = {
  id: string;
  isSelected: boolean;
  onSelect: () => void;
  onDoubleClick?: () => void;
  isMinimal?: boolean;
  onInfoIconClick?: () => void;
  name: string;
  productNumber?: string;
  type?: string;
  image?: string;
};

export const ItemCard = (props: Props) => {
  const { id, isSelected, onSelect, onDoubleClick, isMinimal = false, onInfoIconClick, name, type, image, productNumber } = props;

  const theme = useTheme();

  return (
    <Box
      key={id}
      onClick={onSelect}
      onDoubleClick={onDoubleClick}
      {...getClickableProps(onSelect, onDoubleClick)}
      sx={{
        userSelect: "none",
        cursor: "pointer",
        width: "100%",
        border: isSelected ? `2px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.customColors.grey}`,
        borderRadius: 1,
        outline: "none",
        "&:focus-visible": { outline: `2px solid ${theme.palette.primary.main}` },
        "&:hover .item-card-info-btn": { opacity: 1 }
      }}
    >
      <Box sx={{ position: "relative", overflow: "hidden", lineHeight: 0 }}>
        {!isMinimal && <img src={image || productImage} alt="dummy picture" width="100%" height={ITEM_CARD_IMAGE_HEIGHT} style={{ objectFit: "cover" }} />}
        {isSelected && (
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: `${theme.palette.primary.main}66`
            }}
          />
        )}
        {onInfoIconClick && (
          <IconButton
            k={genericTranslationsK.dynamicValue}
            className="item-card-info-btn"
            size="small"
            onClick={e => {
              e.stopPropagation();
              onSelect();
              onInfoIconClick();
            }}
            sx={{
              position: "absolute",
              top: 4,
              right: 4,
              opacity: 0,
              transition: "opacity 0.2s",
              backgroundColor: theme.palette.background.paper,
              borderRadius: 1,
              "&:hover": { backgroundColor: theme.palette.background.paper }
            }}
          >
            <DekoxIcon icon="info" fontSize="small" />
          </IconButton>
        )}
      </Box>
      <Stack px={1.5} py={1.2}>
        <Typography color={isSelected ? "primary" : ""} variant="body2" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {name}
        </Typography>
        {productNumber && <Typography variant="caption">{productNumber}</Typography>}
        {type && <Typography variant="caption">{type}</Typography>}
      </Stack>
    </Box>
  );
};
